import React, { useState, useMemo } from "react";
import Card from "./UI/Card";
import { BsGithub } from "react-icons/bs";

import { ImGithub, ImLinkedin, ImLinkedin2 } from "react-icons/im";
import { AiFillLinkedin } from "react-icons/ai";
import { SiDiscord, SiDocusign, SiGithub, SiLinkedin } from "react-icons/si";
import { IoMdDownload } from "react-icons/io";
import { Link } from "react-router-dom";

import good from "../Assets/img/UI/banner4.png";

const Banner = ({ homeElement }) => {
  const [state, setstate] = useState(true);

  console.log(homeElement);
  useMemo(() => {
    if (homeElement === "invisible") {
      setstate(false);
    } else {
      setstate(true);
    }
  }, [homeElement]);

  console.log(state);

  let value = "";
  if (homeElement == "") {
    value = "p-4 text-2xl md:pt-0 md:p-8 md:text-4xl";
  } else {
    value = "";
  }
  return (
    <Card glareEnable="true">
      <div className="bg-gray-900 rounded-lg shadow-xl shadow-black">
        <img src={good} alt="header banner" className="w-full " />

        <div className="flex items-center justify-center w-full -mt-10 h-28 md:h-52 md:-mt-16 lg:-mt-20">
          <div className="w-24 h-24 border-[6px] border-violet-700 overflow-hidden  rounded-full md:w-44 md:h-44 bg-[#7DB3E3] justify-self-auto ">
            <img
              src={require("../Assets/img/UI/profile.png")}
              alt=""
              className="h-full mx-auto my-0"
            />
          </div>
        </div>
        <div className="flex justify-between w-full px-6 -mt-1 md:pb-12 md:-mt-20 ">
          <div className="flex gap-5 md:pl-4 ">
            <Link to="https://github.com/ManSOorcode" target="_blank">
              <SiGithub className="text-3xl md:text-4xl" />
            </Link>
            <Link
              to="https://www.linkedin.com/in/mansoor-k-890311116/"
              target="_blank"
            >
              <SiLinkedin className="text-3xl md:text-4xl  text-[#0a66c2] bg-white rounded-md" />
            </Link>
          </div>

          <div className="flex gap-5 md:pr-4 ">
            <Link to="https://discord.gg/6m4EerHdhu" target="_blank">
              <SiDiscord className="text-3xl md:text-4xl text-[#7289da] " />
            </Link>
            <a
              href="https://drive.google.com/file/d/1kJcwLl5wbu2DzKBnAFUTh5apjn3flSHQ/view?usp=sharing"
              target={"_blank"}
              rel="noreferrer"
              download
            >
              <SiDocusign className="text-3xl text-green-400 md:text-4xl " />
            </a>
          </div>
        </div>

        {state && (
          <div className={value || homeElement}>
            <h1>Mansoor Khan</h1>
            <p className="text-xl text-slate-400"># member</p>
          </div>
        )}
        {!state && <div className="pb-4"></div>}
      </div>
    </Card>
  );
};

export default Banner;
